import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { PacsAccessRulesKeyEnum } from './pacs-access-rules-key.enum';
import { PacsAccessRulesConst } from './pacs-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class PacsAccessService extends BaseAccessService<PacsAccessRulesKeyEnum> {
  public constructor() {
    super(PacsAccessRulesConst);
  }

  public get pacsRights() {
    return {
      isModuleEnabled: this.globalService.isAccessRule(PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_ENABLED]),

      canReadEquipment: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_EQUIPMENT_READ]
      ),
      canWriteEquipment: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_EQUIPMENT_WRITE]
      ),

      canReadEventReport: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_EVENT_REPORT_READ]
      ),

      canReadComingGoing: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_COMING_GOING_READ]
      ),

      canReadPhotoVerification: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_PHOTO_VERIFICATION_READ]
      ),

      canReadAccessCardControl: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_ACCESS_CARD_CONTROL_READ]
      ),

      canReadAccessCard: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_ACCESS_CARD_READ]
      ),
      canWriteAccessCard: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_ACCESS_CARD_WRITE]
      ),

      canReadPassageTask: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_TASK_READ]
      ),
      canWritePassageTask: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_TASK_WRITE]
      ),

      canReadPassageOrder: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_ORDER_READ]
      ),
      canWritePassageOrder: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_ORDER_WRITE]
      ),

      canReadPassageOrderEmployee: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_ORDER_EMPLOYEE_READ]
      ),
      canWritePassageOrderEmployee: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_PASSAGE_ORDER_EMPLOYEE_WRITE]
      )
    };
  }

  public get pacsPermissions() {
    return {
      canOpenDoors: this.globalService.isAccessRule(PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_OPEN_DOORS]),
      canSynchronizeConverters: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_SYNCHRONIZE_CONVERTERS]
      ),
      canAccessToAllRooms: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_ACCESS_TO_ALL_ROOMS]
      ),
      canBlockExternalUserAccess: this.globalService.isAccessRule(
        PacsAccessRulesConst[PacsAccessRulesKeyEnum.PACS_PACS_EXTERNAL_USER_BLOCK_PACS_ACCESS]
      )
    };
  }
}
